import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, LogIn } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cs_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex items-center justify-center px-4 grain-overlay">
      <Seo title="Area Riservata — Capital Stone S.r.l." description="Area riservata Capital Stone S.r.l." path="/admin" noindex />
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md"
        data-testid="admin-login-modal"
      >
        <Link
          to="/"
          data-testid="admin-back-home-link"
          className="flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-zinc-500 hover:text-[#D4AF37] transition-colors duration-300 mb-8"
        >
          <ArrowLeft size={14} /> Torna al sito
        </Link>

        <div className="border border-amber-500/15 bg-[#121216] p-8 sm:p-10">
          <img src="/logo.png" alt="Capital Stone S.r.l." className="h-12 w-auto mb-2" />
          <p className="text-xs tracking-[0.3em] uppercase font-mono text-amber-400/80 mb-8">Area Riservata</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">Email</label>
              <input
                data-testid="admin-input-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@capitalstone.it"
                className="input-lux"
              />
            </div>
            <div>
              <label className="block text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">Password</label>
              <input
                data-testid="admin-input-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="input-lux"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="text-sm text-red-400 border border-red-400/25 bg-red-400/10 px-4 py-3">
                {error}
              </p>
            )}
            <button
              data-testid="admin-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-3 bg-[#D4AF37] text-[#0A0A0C] text-xs tracking-[0.2em] uppercase font-semibold px-8 py-4 hover:bg-[#F3E5AB] transition-colors duration-300 disabled:opacity-50"
            >
              <LogIn size={15} />
              {loading ? "Accesso in corso..." : "Accedi"}
            </button>
          </form>
        </div>
      </motion.div>
    </main>
  );
}
